import { getReceiverState, updateReceiverState } from './ReceiverStore'
import { notifyStepChange, notifyIngredientsToggle } from '../cast/MessageSender'

/**
 * Hook-like utility for recipe navigation
 * @returns Navigation functions for recipe steps
 */
export function createRecipeNavigation() {
  // Additional debugging info
  console.log('Creating recipe navigation functions');
  const state = getReceiverState();
  console.log('Current recipe state:', {
    hasRecipe: !!state.recipe,
    currentStepIndex: state.currentStepIndex,
    totalSteps: state.recipe?.steps?.length || 0
  });
  const goToNextStep = () => {
    console.log('⏭️ goToNextStep function called');
    const state = getReceiverState()
    if (!state.recipe) return
    
    const totalSteps = state.recipe.steps?.length || 0
    if (state.currentStepIndex < totalSteps - 1) {
      const newIndex = state.currentStepIndex + 1
      updateReceiverState({ currentStepIndex: newIndex })
      notifyStepChange(newIndex)
    }
  }
  
  const goToPreviousStep = () => {
    console.log('⏮️ goToPreviousStep function called');
    const state = getReceiverState()
    if (!state.recipe) return
    
    if (state.currentStepIndex > 0) {
      const newIndex = state.currentStepIndex - 1
      updateReceiverState({ currentStepIndex: newIndex })
      notifyStepChange(newIndex)
    }
  }
  
  const goToStep = (stepIndex: number) => {
    console.log(`🎯 goToStep function called with index: ${stepIndex}`);
    const state = getReceiverState()
    if (!state.recipe) return
    
    const totalSteps = state.recipe.steps?.length || 0
    const newIndex = Math.max(0, Math.min(stepIndex, totalSteps - 1))
    
    updateReceiverState({ currentStepIndex: newIndex })
    notifyStepChange(newIndex)
  }
  
  return {
    goToNextStep,
    goToPreviousStep,
    goToStep
  }
}

/**
 * Toggles the ingredients view
 */
export function toggleIngredientsView(show?: boolean) {
  console.log(`🔍 toggleIngredientsView called with show: ${show}`);
  const state = getReceiverState()
  const showingIngredients = show !== undefined ? show : !state.showingIngredients
  
  updateReceiverState({ showingIngredients })
  notifyIngredientsToggle(showingIngredients)
}

/**
 * Updates the servings amount
 */
export function updateServings(servings: number) {
  console.log(`🍲 updateServings called with servings: ${servings}`);
  if (servings <= 0) return
  
  updateReceiverState({ servings })
}

/**
 * Gets the current recipe
 */
export function getCurrentRecipe() {
  const state = getReceiverState()
  return state.recipe
}

/**
 * Gets the current step
 */
export function getCurrentStep() {
  const state = getReceiverState()
  if (!state.recipe || !state.recipe.steps) return null
  
  return state.recipe.steps[state.currentStepIndex]
}

/**
 * Gets recipe ingredients adjusted for current servings
 */
export function getAdjustedIngredients() {
  const state = getReceiverState()
  if (!state.recipe || !state.recipe.ingredients) return []
  
  const originalServings = state.recipe.servings || 4
  const ratio = state.servings / originalServings
  
  return state.recipe.ingredients.map((ingredient: any) => {
    if (typeof ingredient.quantity === 'number') {
      return {
        ...ingredient,
        quantity: (ingredient.quantity * ratio).toFixed(1).replace(/\.0$/, '')
      }
    }
    return ingredient
  })
}
